import gql from 'graphql-tag';

import { useQuery } from '@apollo/client';
import { GetWebSession } from '../../athena/types/GetWebSession';

export const GET_WEB_SESSION = gql`
  query GetWebSession {
    web {
      userSession {
        human {
          token
          email
          organizations {
            uuid
          }
          vendorBranches {
            id
            name
            vendor {
              id
              name
            }
          }
        }
      }
    }
  }
`;

const useWebSession = () => useQuery<GetWebSession>(GET_WEB_SESSION);

export default useWebSession;
